import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Navbar.css";
import { useAuthContext } from "../../hooks/useAuthContext";
import {
  List,
  Envelope,
  HouseDoorFill,
  BellFill,
  Bell,
  EnvelopePlusFill,
} from "react-bootstrap-icons";
import axios from "axios";
import { NavDropdown } from "react-bootstrap";
import { ApiConnectionString } from "../../constants/ApiConntection";
import Notifications from "../../pages/notifications/Notifications";
import Inbox from "../../pages/Inbox/Inbox";
import MemboticLogo from "../../assets/MemboticLogo.png";
import PWA from "./PWA"


export default function Navbar({ inboxCount, notificationCount, refreshData, isStandalone }) {
  const { user, dispatch } = useAuthContext();

  const [loading, setLoading] = useState(false);
  const [notificationsShowing, setNotificationsShowing] = useState(false);
  const [inboxShowing, setInboxShowing] = useState(false);
  const location = useLocation();
  const navi = useNavigate();

  const closeNoteAndInbox = () => {
    setNotificationsShowing(false)
    setInboxShowing(false)
  }

  const toggleNotifications = () => {
    setInboxShowing(false);
    setNotificationsShowing(!notificationsShowing);
  };

  const toggleInbox = () => {
    setNotificationsShowing(false);
    setInboxShowing(!inboxShowing);
  };

  useEffect(() => {
    if (user) {
      setLoading(true);
      refreshData();
    }
  }, [user, location, refreshData]);

  if (!user) {
    return (
      <div className="bg-white">
       <nav className="navbar">
  <div className="container">
    <div className="d-flex justify-content-between align-items-center w-100 position-relative">

      {/* Empty div for spacing on the left */}
      <div className="invisible" style={{ width: '33.33%' }}></div>

      {/* Centered logo */}
      <div className="position-absolute start-50 translate-middle-x">
        <Link to="/">
          <img
            src={MemboticLogo}
            className="logo"
            alt="Membotic - All your fitness clubs and activities together"
            title="Membotic - All your fitness clubs and activities together"
          />
        </Link>
      </div>

      {/* Menu on the right */}
      <div className="d-flex justify-content-end" style={{ width: '33.33%' }}>
        <div className="d-flex pt-4 ms-auto">
          <NavDropdown
            title={<List className="offlineHambuger" />}
            className="dropdown-toggle custom-dropdown"
            align="end"
          >
            <NavDropdown.Item className="fw-bold my-4" onClick={() => navi("/")}>
              HOME
            </NavDropdown.Item>
            <NavDropdown.Item className="fw-bold my-4" onClick={() => navi("/searchclubs")}>
              SEARCH CLUBS
            </NavDropdown.Item>
            <NavDropdown.Item className="fw-bold my-4" onClick={() => navi("/aboutus")}>
              ABOUT US
            </NavDropdown.Item>
            <NavDropdown.Item className="fw-bold my-4" onClick={() => navi("/contactus")}>
              CONTACT US
            </NavDropdown.Item>
            {!isStandalone && (
              <NavDropdown.Item className="fw-bold my-4" onClick={() => navi("/downloadtheapp")}>
                DOWNLOAD THE APP
              </NavDropdown.Item>
            )}
            <NavDropdown.Item className="fw-bold my-4" onClick={() => navi("/login")}>
              SIGN IN
            </NavDropdown.Item>
            <NavDropdown.Item className="fw-bold my-4 join-button" onClick={() => navi("/register")}>
              JOIN MEMBOTIC
            </NavDropdown.Item>
          </NavDropdown>
        </div>
      </div>

    </div>
  </div>
</nav>

 
      </div>
    );
  }

  return (
    <div className="bg-white">
    <div className="container">
      <div className="d-flex justify-content-center">
        <Link to="/">
          <img
            src={MemboticLogo}
            className="login-logo"
            alt="Membotic - All your fitness clubs and activities together"
            title="Membotic - All your fitness clubs and activities together"
          />
        </Link>
      </div>

      <div className="d-flex justify-content-end navbar mb-0">
        <ul className="mb-0 mx-3">
          <li>
            {/* {inboxCount > 0 && (
                 <div className="notification-badge">
                   <p className="count-badge">{inboxCount}</p>
                 </div>
               )} */}
            {!inboxCount > 0 ? (
              <Envelope onClick={toggleInbox}/>
            ) : (
              <EnvelopePlusFill  onClick={toggleInbox} color="#ffc107" />
            )}
          </li>
          <li>
            {/* {notificationCount > 0 && (
                 <div className="notification-badge">
                   <p className="count-badge">{notificationCount}</p>
                 </div>
               )} */}

            {notificationCount > 0 ? (
              <BellFill onClick={toggleNotifications} color="#ffc107" />
            ) : (
              <Bell onClick={toggleNotifications} />
            )}
          </li>
          <li>
            <NavDropdown
              title={<List />}
              className="dropdown-toggle custom-dropdown"
            >
              <NavDropdown.Item className="" onClick={() => navi("/")}>
                Home
              </NavDropdown.Item>
              <NavDropdown.Item
                className=""
                onClick={() => navi("/searchclubs")}
              >
                Search Clubs
              </NavDropdown.Item>
              <NavDropdown.Item
                className=""
                onClick={() => navi("/AccountDetails")}
              >
                My Account
              </NavDropdown.Item>
              <NavDropdown.Item className="" onClick={() => navi("/myprofile")}>
                My Profiles
              </NavDropdown.Item>

              <NavDropdown.Item className="" onClick={() => navi("/Settings")}>
                Settings
              </NavDropdown.Item>

              <NavDropdown.Item
                className=""
                onClick={() => navi("/HelpAndSupport")}
              >
                Help & Support
              </NavDropdown.Item>
              <NavDropdown.Item
                className=""
                onClick={() => navi("/MySubscriptionsAndTokens")}
              >
                Subscriptions and Tokens
              </NavDropdown.Item>
              <NavDropdown.Item
                className=""
                onClick={() => navi("/BillingAndPayments")}
              >
                Billing and Payments
              </NavDropdown.Item>
              <NavDropdown.Item className="" onClick={() => navi("/Bookings")}>
                Bookings
              </NavDropdown.Item>
         {!isStandalone &&        <NavDropdown.Item className="" onClick={() => navi("/DownLoadTheApp")}>
                Download The App
              </NavDropdown.Item>}
              <NavDropdown.Divider />
              <NavDropdown.Item
                className=""
                onClick={() => navi("/CreateClub")}
              >
                Create a Club
              </NavDropdown.Item>
              <NavDropdown.Divider />
        

              <NavDropdown.Item
                className=""
                onClick={() => navi(`/MyClubs/${user.id}`)}
              >
                My Clubs
              </NavDropdown.Item>

              <NavDropdown.Divider />
              <NavDropdown.Item
                className=""
                onClick={async () => {
                  await navi("/");
                  dispatch({ type: "LOGOUT" });
                }}
              >
                Logout
              </NavDropdown.Item>
            </NavDropdown>
          </li>
        </ul>
      </div>


      {notificationsShowing && <Notifications refreshData={refreshData} closeNoteAndInbox={closeNoteAndInbox}/>}
      {inboxShowing && <Inbox closeNoteAndInbox={closeNoteAndInbox}/>}
    </div>
    </div>
  );
}
